import { createContext, useContext } from "react";
import { useAppContext } from "./AppContext";
import { useFetch } from "../hooks/useFetch";
import { get_xflow_receivables } from "../constants/apis";
import { XflowReceivableRes } from "../types/XFlow";
import { useSearchParams } from "react-router-dom";

type Receivable = {
  data: XflowReceivableRes[] | null;
  loading: boolean;
  refetch: () => void;
};

const XFlowReceivablesContext = createContext<Receivable | null>(null);

export const XFlowReceivablesContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { jwtToken } = useAppContext();

  const [searchParams] = useSearchParams();
  const partner_id = searchParams.get("partner_id");

  const { data, loading, refetch } = useFetch<XflowReceivableRes[]>(
    get_xflow_receivables,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        Content_Type: "application/json",
      },
      body: JSON.stringify({ partner_id }),
    },
    partner_id!
  );

  return (
    <XFlowReceivablesContext.Provider value={{ data, loading, refetch }}>
      {children}
    </XFlowReceivablesContext.Provider>
  );
};

export const useXFlowReceivablesContext = () => {
  const context = useContext(XFlowReceivablesContext);

  if (!context) throw new Error("Context must be used within an provider");

  return context;
};
